import React from 'react';

interface TeamLogoProps {
  abbreviation: string;
  color: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = { sm: 'w-7 h-7 text-xs', md: 'w-9 h-9 text-sm', lg: 'w-12 h-12 text-base' };

export default function TeamLogo({ abbreviation, color, size = 'md' }: TeamLogoProps) {
  return (
    <div
      className={`${SIZE_MAP[size]} rounded-md flex items-center justify-center font-bold font-mono-data flex-shrink-0`}
      style={{ backgroundColor: `${color}22`, border: `1px solid ${color}55`, color }}
    >
      {abbreviation}
    </div>
  );
}